module.exports = __webpack_public_path__ + "img/csv.dfbd9499.svg";